import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-unresolved-flags-chip',
  templateUrl: './unresolved-flags-chip.component.html',
  styleUrls: ['./unresolved-flags-chip.component.scss'],
})
export class UnresolvedFlagsChipComponent {}
